/**
 * External dependencies
 */
/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';
import * as controller from './controller';

// export default (router) => {
//     router(`/dashboard/roam`, controller.roam, makeLayout, render);
// };


export default (router) => {
    router(`/dashboard/visual-deck`, controller.plan, makeLayout, render);
    router(`/dashboard/visual-deck/edit`, controller.editPlan, makeLayout, render);
    router(`/dashboard/visual-deck/subscribe`, controller.newPlan, makeLayout, render);
};